import axios from '../../../utils/api/axiosInstance';

export async function fetchPortalBasedOnId(id: number, isGuest: boolean, shareParam?: string | null, keyParam?: string | null) {
  const url = isGuest
    ? `/api/guest/portal/${id}/settings`
    : `/api/portal/${id}/settings`;

  // Add share or key parameter to the request if it exists
  const params: { share?: string; key?: string } = {};
  if (shareParam) params.share = shareParam;
  if (keyParam) params.key = keyParam;

  try {
    const response = await axios.get(url, { params });
    return JSON.parse(response.data.results);
  } catch (error) {
    console.log('Axios: ', error);
    throw error;
  }
}

export async function fetchPortalStationConfig() {
  try {
    const response = await axios.get(`/api/settings/`);
    return response.data.results;
  } catch (error) {
    // const errorObj = error as any;
    // const message = errorObj.response.data.message as string;
    console.log(error);
    // throw new Error(message);
  }
}
